import { inject, Injectable } from '@angular/core';
import { StateContext } from '@ngxs/store';
import { TableStateModel } from '../table.state.model';
import { Pagination } from '@core/models/pagination.model';
import { TableActions } from '../table.actions';
import { UpdateApprovalService } from '@core/services/update-approvals';
import { catchError, tap, throwError } from 'rxjs';
import { NotificationFacade } from '@core/facades/notification.facade';

@Injectable({
  providedIn: 'root',
})
export class UpdateApprovalsHandler {
  constructor() {}
  updateApprovalService = inject(UpdateApprovalService);
  notify = inject(NotificationFacade);

  handleUpdateApprovalsLoad(
    ctx: StateContext<TableStateModel>,
    params: Pagination
  ) {
    this.updateApprovalService.getApprovalList({ ...params }).subscribe({
      next: (response) => {
        ctx.dispatch(
          new TableActions.LoadTableDataSuccess({
            tableKey: 'updateApprovals',
            data: response.data?.data,
            totalCount: response.data?.total_count,
          })
        );
      },
      error: (error) => {
        ctx.dispatch(
          new TableActions.LoadTableDataFailure({
            tableKey: 'updateApprovals',
            error: error.message,
          })
        );
      },
    });
  }

  approveUpdate(
    ctx: StateContext<TableStateModel>,
    action: TableActions.ApproveUpdate
  ) {
    return this.updateApprovalService
      .processUpdate(action.payload.updateId, action.payload.action)
      .pipe(
        tap(() => {
          // Optionally, you can refresh the list or update the state here
          const currentState = ctx.getState();
          const updatedOrders = currentState.updateApprovals?.data.map(
            (approval) =>
              approval.combined_id === action.payload.updateId
                ? {
                    ...approval,
                    status:
                      action.payload.action === 'approved'
                        ? 'approved'
                        : 'rejected',
                  }
                : approval
          );
          ctx.patchState({
            updateApprovals: {
              ...currentState.updateApprovals,
              data: updatedOrders,
            },
          } as Partial<TableStateModel>);
        }),
        catchError((error) => {
          this.notify.error('Failed to approve update');
          return throwError(() => error);
        })
      );
  }

  handleGetApprovalMetadata(ctx: StateContext<TableStateModel>) {
    this.updateApprovalService.getUpdatesMetadata().subscribe({
      next: (response) => {
        ctx.patchState({
          updateApprovals: {
            ...ctx.getState().updateApprovals,
            updatesMetadata: response.data,
          },
        } as Partial<TableStateModel>);
      },
      error: (error) => {
        ctx.dispatch(
          new TableActions.LoadTableDataFailure({
            tableKey: 'updateApprovals',
            error: error.message,
          })
        );
      },
    });
  }

  filterUpdateApprovalList(
    ctx: StateContext<TableStateModel>,
    action: TableActions.FilterApprovalList
  ) {
    const query = action.payload.filter;
    this.updateApprovalService.getApprovalList(undefined, query).subscribe({
      next: (response) => {
        ctx.dispatch(
          new TableActions.LoadTableDataSuccess({
            tableKey: 'updateApprovals',
            data: response.data?.data,
            totalCount: response.data?.total_count,
          })
        );
      },
      error: (error) => {
        ctx.dispatch(
          new TableActions.LoadTableDataFailure({
            tableKey: 'updateApprovals',
            error: error.message,
          })
        );
      },
    });
  }
}
